import React from 'react';
import LazyImage from './LazyImage.jsx';
import '../styles/Card.css';
import fallbackImg from '../assets/images/Clipart Fallback Invitations.webp';

const Card = ({ title, description, image, onClick, className = '', category, categoryLabel }) => {
  const src = image || fallbackImg;

  return (
    <div className={`card ${className}`} onClick={onClick}>
      <div className="card-image">
        <LazyImage
          src={src}
          alt={title}
          className="card-lazy-image"
          wrapperClassName="card-lazy-wrapper"
          effect="blur"
          threshold={150}
          placeholderSrc={fallbackImg}
        />
      </div>
      <div className="card-content">
        {title && (
          <div className="card-title-wrapper">
            <h3 className="card-title">{title}</h3>
            {category && categoryLabel && (
              <span className={`category-badge ${category}`}>
                {categoryLabel}
              </span>
            )}
          </div>
        )}
        {description && <p className="card-description">{description}</p>}
      </div>
    </div>
  );
};

export default Card;
